import { Component, Input, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalModel } from '../../models/core/modal.model';

@Component({
  selector: 'ben-modal',
  templateUrl: 'modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() info: ModalModel = new ModalModel();
  constructor(public dialog: MatDialog) { }

  openDialog(templateRef: TemplateRef<any>) {
    let dialogRef = this.dialog.open(templateRef, {
      width: '80%',
      height: 'auto'
    });
  }
}





